import axios from "axios";
import { toast } from "react-toastify";
import { START_CALL } from "../Types/CallTypes";

const apiUrlCall = process.env.REACT_APP_API_URL + "call/";

export const setMakeCall = ({
  phoneNo,
  agentStatus,
  goToACW,
  contactID,
  campaignID,
  phoneTypeID,
  ACWMode,
  ACWDuration,
  isTelemarketing,
  isWACall = false,
}) => {
  return async (dispatch) => {
    if (agentStatus === "READY") {
      try {
        const config = {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        };
        const response = await axios.get(
          `${apiUrlCall}setmakecall?phoneNo=${phoneNo}&contactid=${
            contactID ? contactID : ""
          }&iswacall=${isWACall}`,
          config
        );
        console.log("setMakeCall:", response.data);

        return dispatch({
          type: START_CALL,

          payload: {
            phoneNumber: phoneNo,
            goToACW: goToACW,
            contactID: contactID,
            type: "outbound",
            campaignID: campaignID,
            phoneTypeID: phoneTypeID || phoneTypeID === 0 ? phoneTypeID : null,
            ACWMode: ACWMode,
            ACWDuration: ACWDuration,
            isTelemarketing: isTelemarketing
          },
        });
        // return response.data;
      } catch (error) {
        return {
          status: false,
          error:
            "API setMakeCall: " +
            (error.response && error.response.data
              ? error.response.data.error
              : error.message
              ? error.message
              : "Failed!"),
        };
      }
    } else {
      toast.warn("Please change your status to Ready to make calls", {
        autoClose: 3000,
      });
    }
  };
};

export const setDisconnectCall = async (actionid) => {
  // For later (transfer, etc)
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };
    const response = await axios.get(
      `${apiUrlCall}sethangupcall?actionid=${actionid}`,
      config
    );
    console.log("setDisconnectCall:", response.data);
    return response.data;
  } catch (error) {
    return {
      status: false,
      error:
        "API setDisconnectCall: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getRecording = async (actionid, uniqueid) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };
    const response = await axios.get(
      `${apiUrlCall}getrecording?actionid=${actionid}&uniqueid=${uniqueid}`,
      config
    );
    console.log("getRecording:", response.data);
    return response.data;
  } catch (error) {
    return {
      status: false,
      error:
        "API getRecording: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getRecordingFiles = async (actiondata, signal) => { // signal used to abort the request
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      signal: signal,
    };
    const response = await axios.get(
      `${apiUrlCall}getrecordingfiles?actiondata=${actiondata}`,
      config
    );
    return response.data;
  } catch (error) {
    if (error.name === "AbortError") {
      return { status: false, error: "Request cancelled" };
    }
    return {
      status: false,
      error:
        "API getRecordingFiles: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getLogCall = async (payload) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const body = {
      datestart: payload.dateStart,
      dateend: payload.dateEnd,
      inheritleaderid: 0, // Hardcoded
      agentlevel: payload.agentlevel,
      searchkeyword: payload.searchkeyword,
      calltype: payload.calltype,
      filteragentids: payload.filteragentids,
      page: payload.page === null ? null : payload.page ? payload.page : 1,
    };

    const response = await axios.post(`${apiUrlCall}getlogcall`, body, config);

    return response.data;
  } catch (error) {
    return {
      status: false,
      error:
        "API getLogCall: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getACDISPlan = async (ACDDeviceID) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(
      `${apiUrlCall}getacdisplan?acddeviceid=${ACDDeviceID}`,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getACDISPlan: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getCampaignISPlan = async (campaignID) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(
      `${apiUrlCall}getcampaignisplan?campaignid=${campaignID}`,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getCampaignISPlan: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const answerCall = async (queue, ext) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(
      `${apiUrlCall}answercall?queue=${queue}&ext=${ext}`,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API answerCall: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const setTransfer = async (destination, actionID, type) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(
      `${apiUrlCall}settransfer?destext=${destination}&actionid=${actionID}&transfertype=${type}&setvar=null`,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API setTransfer: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getActiveCall = async (payload) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.post(
      `${apiUrlCall}getactivecall`,
      payload,
      config
    );
    return response.data;
  } catch (error) {
    return {
      status: false,
      error:
        "API getActiveCall: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const setParkCall = async (actionID, parkerExt) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(
      `${apiUrlCall}setparkcall?actionid=${actionID}&parkerext=${parkerExt}`,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API setParkCall: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const setOriginate = async (payload) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.post(
      `${apiUrlCall}setOriginate`,
      payload,
      config
    );
    return response.data;
  } catch (error) {
    return {
      status: false,
      error:
        "API setOriginate: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const setSocketNotification = async (payload) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.post(
      `${apiUrlCall}setsocketnotification`,
      payload,
      config
    );
    return response.data;
  } catch (error) {
    return {
      status: false,
      error:
        "API setSocketNotification: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const saveACDInteraction = async (payload) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.post(
      `${apiUrlCall}saveacdinteraction`,
      payload,
      config
    );
    return response.data;
  } catch (error) {
    return {
      status: false,
      error:
        "API saveACDInteraction: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getExtension = async (sessionID) => {
  try {
    const response = await axios.get(
      `${apiUrlCall}getextension?sessionid=${sessionID}`
    );

    return response.data;
  } catch (error) {
    return {
      status: false,
      error:
        "API getExtension: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const setUsedExtension = async (sessionID) => {
  try {
    const response = await axios.get(
      `${apiUrlCall}useextension?sessionid=${sessionID}`
    );

    return response.data;
  } catch (error) {
    return {
      status: false,
      error:
        "API useExtension: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const releaseExtension = async (sessionID) => {
  try {
    const response = await axios.get(
      `${apiUrlCall}releaseextension?sessionid=${sessionID}`
    );

    return response.data;
  } catch (error) {
    return {
      status: false,
      error:
        "API releaseExtension: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getSpeechToText = async (payload) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.post(
      `${apiUrlCall}getspeechtotext`,
      payload,
      config
    );
    return response.data;
  } catch (error) {
    return {
      status: false,
      error:
        "API getSpeechToText: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getScreenRecording = async (uniqueID) => {
  try {
    const response = await axios.get(
      `${apiUrlCall}getscreenrecording?uniqueid=${uniqueID}`
    );

    return response.data;
  } catch (error) {
    return {
      status: false,
      error:
        "API getScreenRecording: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const addScreenRecording = async (payload) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.post(
      `${apiUrlCall}addscreenrecording`,
      payload,
      config
    );
    return response.data;
  } catch (error) {
    return {
      status: false,
      error:
        "API addScreenRecording: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const createInAppCallSession = async (payload) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.post(
      `${apiUrlCall}createinappcallsession`,
      payload,
      config
    );
    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API createInAppCallSession: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
            ? error.message
            : "Failed!"),
    };
  }
};

export const checkInAppCallSession = async (sessionID) => {
  try {
    const response = await axios.get(
      `${apiUrlCall}checkinappcallsession?sessionid=${sessionID}`
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API checkInAppCallSession: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
            ? error.message
            : "Failed!"),
    };
  }
};

export const startInAppCallSession = async (payload) => {
  try {
    const response = await axios.post(
      `${apiUrlCall}startinappcallsession`,
      payload
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API startInAppCallSession: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
            ? error.message
            : "Failed!"),
    };
  }
};

export const endInAppCallSession = async (payload) => {
  try {
    const response = await axios.post(
      `${apiUrlCall}endinappcallsession`,
      payload
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API endInAppCallSession: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
            ? error.message
            : "Failed!"),
    };
  }
};

export const addInAppCallSessionRetryValue = async (payload) => {
  try {
    const response = await axios.post(
      `${apiUrlCall}addinappcallsessionretryvalue`,
      payload
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API addInAppCallSessionRetryValue: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
            ? error.message
            : "Failed!"),
    };
  }
};
